import { ErrorPage, LoadingPage } from '../components/resource-state';
import { loadManifest, type Manifest } from '../content/data';
import { useResource } from '../content/use-resource';
import { AppShell } from '../layout/app-shell';
import { useRoute, type Route } from '../navigation/routes';
import { Onboarding } from '../onboarding/onboarding';
import { ProjectPage, ProjectsPage, RoadmapPage, WeekPage } from '../pages/curriculum-pages';
import { FixturePage, GuidePage, GuidesPage } from '../pages/guide-pages';
import { InterviewPage } from '../pages/interview-page';
import { SettingsPage } from '../pages/settings-page';
import { SummaryPage } from '../pages/summary-page';
import { TodayPage } from '../pages/today-page';
import { useProgress } from '../progress/progress-context';

function CurrentPage({ manifest, route }: { manifest: Manifest; route: Route }) {
  switch (route.page) {
    case 'today':
      return <TodayPage manifest={manifest} />;
    case 'summary':
      return <SummaryPage manifest={manifest} />;
    case 'day':
      return <TodayPage manifest={manifest} requestedDayId={route.dayId} />;
    case 'roadmap':
      return <RoadmapPage manifest={manifest} />;
    case 'projects':
      return <ProjectsPage manifest={manifest} />;
    case 'week':
      return <WeekPage manifest={manifest} weekId={route.weekId} />;
    case 'project':
      return <ProjectPage manifest={manifest} weekId={route.weekId} />;
    case 'interview':
      return <InterviewPage manifest={manifest} />;
    case 'guides':
      return <GuidesPage />;
    case 'guide':
      return <GuidePage manifest={manifest} documentId={route.documentId} />;
    case 'fixture':
      return <FixturePage filename={route.filename} />;
    case 'settings':
      return <SettingsPage manifest={manifest} />;
  }
}

export function App() {
  const route = useRoute();
  const progress = useProgress();
  const manifestResource = useResource(loadManifest, []);

  if (manifestResource.status === 'loading') return <LoadingPage />;
  if (manifestResource.status === 'error') {
    return <ErrorPage error={manifestResource.error} retry={manifestResource.retry} />;
  }

  if (!progress.onboardingComplete) return <Onboarding manifest={manifestResource.data} />;

  return (
    <AppShell manifest={manifestResource.data} progress={progress} route={route}>
      <CurrentPage manifest={manifestResource.data} route={route} />
    </AppShell>
  );
}
